<template>
  <span>
    <!-- If user is not logged in, we don't show the default sidebar components.
    Otherwise they are shortly loaded before user gets redirected to keycloak. -->
    <v-container v-if="isLoggedIn">
      <BookHeader />
    </v-container>
    <v-container v-else-if="this.$route.meta.isPublic">
       <PublicHeader />
    </v-container>

    <v-container v-if="isLoggedIn">
      <SidebarComponent />
    </v-container>
  </span>
</template>

<script>
import BookHeader from '@/modules/book/components/Header/BookHeader';
import SidebarComponent from '@/modules/book/components/Sidebar/SidebarComponent';
import {mapGetters} from 'vuex';
import PublicHeader from '@/modules/core/components/Header/PublicHeader';

export default {
  name: 'BookModule',
  components: {
    BookHeader,
    SidebarComponent,
    PublicHeader
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  }
};
</script>
